export default "__VITE_ASSET__l5rCLNc$__"